import { Avatar, Card, CardContent, Typography, useTheme } from "@mui/material";
import { EngineerTestimonialSection } from "../../data/engineerTestimonials";

interface Props {
  testimonial: EngineerTestimonialSection;
}

const EngineerTestimonialCard: React.FC<Props> = ({ testimonial }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        border: `1px solid ${theme.palette.text.disabled}`,
        backgroundColor: theme.palette.background.paper,
        p: { xs: 2, sm: 2, md: 3, lg: 3 },
      }}
    >
      <Avatar
        src={testimonial.image}
        alt={testimonial.name}
        sx={{ width: 64, height: 64, my: 1 }}
      />
      <Typography variant="body1" fontWeight={700}>
        {testimonial.name}
      </Typography>
      {testimonial.title && testimonial.title.trim() !== "" && (
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mb: 1,
          }}
        >
          {testimonial.title}
        </Typography>
      )}

      <CardContent sx={{ p: 0 }}>
        <Typography variant="body1" sx={{ fontStyle: "italic" }}>
          "{testimonial.message}"
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EngineerTestimonialCard;
